export default __webpack_public_path__ + "static/media/img-01.fe01b5ee.png";